import { useEffect } from "react";
import "./EmberAnimation.css";

export default function EmberAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.closest(".battle-bg");
    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const startX = (pRect.left + pRect.width / 2) - cRect.left;
    const startY = (pRect.top + pRect.height / 2) - cRect.top;
    const endX = (oRect.left + oRect.width / 2) - cRect.left;
    const endY = (oRect.top + oRect.height / 2) - cRect.top;

    const embers = [];
    const impactTimers = [];

    // 🔥 FIRE VOLLEY: 5 main embers staggered in
    for (let i = 0; i < 5; i++) {
      const ember = document.createElement("div");
      ember.className = "ember-main";
      ember.style.left = `${startX}px`;
      ember.style.top = `${startY}px`;
      ember.style.transform = `translate(-50%, -50%)`;
      ember.style.animationDelay = `${i * 0.08}s`; // stagger

      const angleOffset = (i - 2) * 4; // slight spread
      const dx = endX - startX + angleOffset;
      const dy = endY - startY + Math.random() * 4 - 2;

      ember.style.setProperty("--dx", `${dx}px`);
      ember.style.setProperty("--dy", `${dy}px`);

      container.appendChild(ember);
      embers.push(ember);
    }



    // 🌋 Impact burst on last ember's finish
    const handleImpact = () => {
      embers.forEach(e => e.remove());

      if (opponentEl) {
        opponentEl.classList.add("ember-hit");
        setTimeout(() => opponentEl.classList.remove("ember-hit"), 250);
      }

      const impactSparks = [];
      for (let i = 0; i < 30; i++) {
        const spark = document.createElement("div");
        spark.className = "ember-spark ember-impact";
        spark.style.left = `${endX}px`;
        spark.style.top = `${endY}px`;

        const angle = Math.random() * 2 * Math.PI;
        const dist = 30 + Math.random() * 30;
        const tx = Math.cos(angle) * dist;
        const ty = Math.sin(angle) * dist;
        spark.style.setProperty("--dx", `${tx}px`);
        spark.style.setProperty("--dy", `${ty}px`);

        container.appendChild(spark);
        impactSparks.push(spark);
      }

      setTimeout(() => {
        impactSparks.forEach(s => s.remove());
        onComplete();
      }, 800);
    };

    const lastEmber = embers[embers.length - 1];
    lastEmber.addEventListener("animationend", handleImpact);

    return () => {
      lastEmber.removeEventListener("animationend", handleImpact);
      embers.forEach(e => e.remove());
      impactTimers.forEach(clearTimeout);
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

EmberAnimation.moveType = "fire";
